<template>
  <div class="order-detail">
    <div v-show="info.productName">
      <div class="product-head">
        <span class="product-name pull-left">{{info.productName}}
          <span class="is-bind-card" v-if="info.hasAutho == 1">(已绑定还款卡)</span>
        </span>
        <span class="time pull-left">签约日期：{{info.signDate}}</span>
      </div>
      <div class="order-table clearfix">
        <div class="order-tdbox" v-if="info.borrowMoney">
          <div class="order-td">借款金额：</div>
          <div class="order-td">{{info.borrowMoney}}元</div>
        </div>
        <div class="order-tdbox" v-if="info.interestRate">
          <div class="order-td">借款月利率：</div>
          <div class="order-td">{{info.interestRate}}%</div>
        </div>
        <div class="order-tdbox" v-if="info.duration">
          <div class="order-td">借款期限：</div>
          <div class="order-td">{{info.duration}}{{info.unit}}</div>
        </div>
        <div class="order-tdbox" v-if="info.interest">
          <div class="order-td">借款利息：</div>
          <div class="order-td">{{info.interest}}元</div>
        </div>
        <div class="order-tdbox" v-if="info.loanMoney">
          <div class="order-td">贷款金额：</div>
          <div class="order-td">{{info.loanMoney}}元</div>
        </div>
        <div class="order-tdbox" v-if="info.loanBank">
          <div class="order-td">申贷银行：</div>
          <div class="order-td">{{info.loanBank}}</div>
        </div>
        <div class="order-tdbox" v-if="info.loanCardNo">
          <div class="order-td">放款卡号：</div>
          <div class="order-td">{{info.loanCardNo}}</div>
        </div>
        <div class="order-tdbox" v-if="info.loanCardName">
          <div class="order-td">放款卡户名：</div>
          <div class="order-td">{{info.loanCardName}}</div>
        </div>
        <div class="order-tdbox" v-if="info.loanCardBank">
          <div class="order-td">放款卡开户行：</div>
          <div class="order-td">{{info.loanCardBank}}</div>
        </div>
        <div class="order-tdbox" v-if="info.loanDate">
          <div class="order-td">放款日期：</div>
          <div class="order-td">{{info.loanDate}}</div>
        </div>
        <div class="order-tdbox" v-if="info.startRepaymentTime">
          <div class="order-td">预计还款时间：</div>
          <div class="order-td">{{info.startRepaymentTime}}</div>
        </div>
        <div class="order-tdbox" v-if="info.successRepaymentTime">
          <div class="order-td">实际还款时间：</div>
          <div class="order-td">{{info.successRepaymentTime}}</div>
        </div>
        <div class="order-tdbox" v-if="info.housePro">
          <div class="order-td">房屋属性：</div>
          <div class="order-td">{{info.housePro}}</div>
        </div>
        <div class="order-tdbox" v-if="info.houseAddr"><!-- 独占一行的className order-tdbox-all -->
          <div class="order-td">房屋地址：</div>
          <div class="order-td" colspan="3">{{info.houseAddr}}</div>
        </div>
      </div>
    </div>
    <Loading
      v-show="!info.productName"
      :height="400">
    </Loading>
  </div>
</template>

<script>
  import Modal from '@/components/modal/modal'
  import Loading from '@/components/combo/loading'
  import PasswordInput from './password-input'

  export default {
    name: 'OrderDetail',
    components: {
      Modal,
      PasswordInput,
      Loading
    },
    data () {
      return {
        info: {}
      }
    },
    created () {
      this.no = this.$route.query.no
      this._fetchData()
    },
    methods: {
      _fetchData () {
        let vm = this
        let token = this.$store.state.token
        this.$http({
          url: '/center/getOrderInfo.jhtml',
          data: {
            uid: token.uid,
            no: this.no
          },
          done (info) {
            vm.info = info || {}
          }
        })
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .product-head
    height 50px
    border-radius 25px
    background-color #fff
    line-height 50px
    padding 0 15px
    margin-bottom 8px
    display inline-block
    font-size 0
    vertical-align middle
    .product-name
      font-size 16px
      color #0068b7
      font-weight bold
      position relative
      padding-right 15px
      margin-right 15px
      .is-bind-card
        padding-left 7px
      &:after
        content ''
        position absolute
        right 0
        top 15px
        width 2px
        height 20px
        background #0068b7
    .time
      font-size 14px
      color #999
    .status
      font-size 14px
      margin-left 20px
    .delete
      font-size 14px
      color rgb(43, 158, 252)
      margin-left 10px
      text-decoration underline
  .order-table
    width 100%
    text-align left
    background url(/static/img/order-table-bg.png) repeat left top
    .order-tdbox
      width 50%
      height 60px
      float left
      // background-color #f4faff
      font-size 14px
      color #666
      strong
        color #333
      &:nth-child(2n+1)
        // background-color #fff
      &.order-tdbox-all
        width 100%
        .order-td
          width 740px
      .order-td
        padding 0 15px
        width 290px
        height 60px
        display table-cell
        vertical-align middle
        overflow hidden
        &:nth-child(2n+1)
          width 130px
</style>



// WEBPACK FOOTER //
// order-detail.vue?b92abcec